import { useEffect } from "react";

export default function HubspotForm() {
  useEffect(() => {
    // Remove old script if exists
    const oldScript = document.getElementById("hubspot-embed-script");
    if (oldScript) oldScript.remove();

    // Create a fresh script tag
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/23359971.js";
    script.defer = true;
    script.id = "hubspot-embed-script";

    // Append script right after the form container
    const formContainer = document.getElementById("hubspotFormContainer");
    if (formContainer) {
      formContainer.innerHTML = `
        <div class="hs-form-frame" 
             data-region="na1" 
             data-form-id="f47e877a-3f53-406f-a5d4-6b3b8a7beb1c" 
             data-portal-id="23359971"></div>
      `;
      formContainer.appendChild(script);
    }

    return () => {
      // Optional cleanup to avoid duplicates
      if (formContainer) formContainer.innerHTML = "";
    };
  }, []);

  return <div id="hubspotFormContainer"></div>;
}

export function HubspotFormOLO() {
  useEffect(() => {
    // Remove old script if exists
    const oldScript = document.getElementById("hubspot-embed-script");
    if (oldScript) oldScript.remove();

    // Create a fresh script tag
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/23359971.js";
    script.defer = true;
    script.id = "hubspot-embed-script";

    // Append script right after the form container
    const formContainer = document.getElementById("hubspotFormContainer");
    if (formContainer) {
      formContainer.innerHTML = `
        <div class="hs-form-frame" 
             data-region="na1" 
             data-form-id="09b13010-e230-4233-81e2-e2508c652e1a" 
             data-portal-id="23359971"></div>
      `;
      formContainer.appendChild(script);
    }

    return () => {
      // Optional cleanup to avoid duplicates
      if (formContainer) formContainer.innerHTML = "";
    };
  }, []);

  return <div id="hubspotFormContainer"></div>;
}

export function HubspotFormReferral() {
  useEffect(() => {
    // Remove old script if exists
    const oldScript = document.getElementById("hubspot-embed-script");
    if (oldScript) oldScript.remove();

    // Create a fresh script tag
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/23359971.js";
    script.defer = true;
    script.id = "hubspot-embed-script";

    // Append script right after the form container
    const formContainer = document.getElementById("hubspotFormContainer");
    if (formContainer) {
      formContainer.innerHTML = `
        <div class="hs-form-frame" data-region="na1" data-form-id="7e902cf8-bd78-4696-a95b-55db93875f90" data-portal-id="23359971"></div>
      `;
      formContainer.appendChild(script);
    }

    return () => {
      // Optional cleanup to avoid duplicates
      if (formContainer) formContainer.innerHTML = "";
    };
  }, []);

  return <div id="hubspotFormContainer"></div>;
}
